import { useEffect, useRef } from "react";
import ZoomServices from "../../../services/ZoomServices";

export default function ZoomCallback() {
  const hasExchanged = useRef(false);

  useEffect(() => {
    if (hasExchanged.current) return;

    const code = new URLSearchParams(window.location.search).get("code");
    if (!code) return;

    hasExchanged.current = true;

    ZoomServices.exchangeCode(code)
      .then(token => {
        // ✅ Send token to parent window
        window.opener.postMessage(
          {
            type: "ZOOM_OAUTH_SUCCESS",
            token
          },
          window.location.origin
        );

        // ✅ Close popup
        window.close();
      })
      .catch(err => {
        console.error(err);

        window.opener.postMessage(
          { type: "ZOOM_OAUTH_FAILED" },
          window.location.origin
        );

        window.close();
      });
  }, []);

  return <p>Connecting to Zoom…</p>;
}
